import React from 'react';
import {
    FormErrorMessage,
    FormLabel,
    FormControl,
    Input,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
} from '@chakra-ui/react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { 
  getDepartments,
  createDepartment,
  connectDepartmantWithCompany,
} from '../../api';
import departmentsState from '../../store/departmentsState';
import { editDepartment } from '../../api';
import { getCompany } from '@/entities/company/api';

interface IFormFileds {
  name: string;
}

export interface EditDepartmentPopupProps {
  isOpen: boolean;
  onClose: () => void;
  department: any;
}

export const EditDepartmentPopup: React.FC<EditDepartmentPopupProps> = ({ isOpen, onClose, department }) => {
  const { 
    register,
    handleSubmit,
    formState: { errors, isSubmitting } 
  } = useForm<IFormFileds>();

  const companyId = JSON.parse(localStorage.getItem('user'))?.company[JSON.parse(localStorage.getItem('user'))?.company.length - 1];

  function handleGetDepartments() {
    getCompany(companyId)
      .then((res: any) => {
        departmentsState.setDepartments(res.data.group);
      })
      .catch((error) => {
        console.log(error);
      })
  }

  const onSubmit: SubmitHandler<IFormFileds> = (data) => {
    editDepartment(data, department.id)
      .then((res: any) => {
        if (res?.status === 200) {
          handleGetDepartments();
          onClose();
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }

  return (
    <Modal size={'xl'} blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <form onSubmit={handleSubmit(onSubmit)}>
          <ModalContent borderRadius={16}>
            <ModalHeader alignItems={'center'}>
              <h3 style={{ textAlign: 'center' }}>Изменить департамент</h3>
            </ModalHeader>
            <ModalCloseButton top={'14px'} />
            <ModalBody
              padding='20px'
              display='flex'
              flexDirection='column'
              gap='30px'
              borderTop='1px solid var(--addable-gray)'
              borderBottom='1px solid var(--addable-gray)'
            >
              <FormControl isInvalid={Boolean(errors.name)}>
                <FormLabel>Название департамента *</FormLabel>
                <Input
                  id='name'
                  {...register('name', { 
                    required: 'Обязательное поле'
                  })}
                  defaultValue={department.name}
                  placeholder='Разработка'
                  type='text'
                  size='sm'
                  variant='flushed'
                />
                <FormErrorMessage>{errors.name && <>{errors.name.message}</>}</FormErrorMessage>
              </FormControl>
            </ModalBody>

            <ModalFooter gap='8px' display='flex'>
              <Button
                type='button'
                width='100%'
                onClick={onClose}
                variant='outline'
                color='var(--main-purple)'
                borderRadius='8px'
              >
                Отмена
              </Button>
              <Button
                type='submit'
                width='100%'
                borderRadius='8px'
                bg='var(--main-purple)'
                _hover={{ bg: 'var(--hover-purple)' }}
                color='#fff'
                isLoading={isSubmitting ? true : false}
              >
                Изменить департамент
              </Button>
            </ModalFooter>
          </ModalContent>
      </form>
    </Modal>
  )
}
